<template>
  <div class="navbar">
<!--    <changeAccount ref="changeRef"></changeAccount>-->

    <!--    <hamburger id="hamburger-container" :is-active="sidebar.opened" class="hamburger-container" @toggleClick="toggleSideBar" />-->

    <!--    <breadcrumb id="breadcrumb-container" class="breadcrumb-container" v-if="!topNav"/>-->
      <div class="left-menu">
        <img class="mr10 icon-logo pointer" src="@/assets/logo-red.png" alt />
        <div class="fcf fz20 pointer">广烁开放平台</div>

        <div class="menu-top pointer" style="padding-left: 50px;color: #FFFFFF">
          首页
        </div>

        <div class="menu-top pointer">
          接入指南
        </div>

        <div class="menu-top pointer">
          API文档
        </div>

        <div class="menu-top pointer">
          帮助文档
        </div>
      </div>



      <div class="right-menu flex">

        <div class="login-box pointer">
          登录
        </div>

        <div class="login-box pointer">
          注册
        </div>

      </div>

    </div>

</template>

<script>
import { mapGetters } from 'vuex'
import changeAccount from "@/pages/customerEnterprise/components/ChangeAccount.vue";
export default {
  components: {changeAccount},
  data() {
    return {
      path: "",
      routeData: [{
        name: '首页',
        path: '/home',
        activePath: '/home',
      }, {
        name: '签署列表',
        path: '/taskList',
        activePath: '/taskList',
      }, {
        name: '创建任务',
      }],
      currentPath: "",
      baseName: process.env.VUE_APP_API_BASE_NAME,
    };
  },
  props:{
    visible: {
      type: Boolean,
      default: false
    },
  },
  computed: {
    ...mapGetters([
      'sidebar',
      'device'
    ]),
    setting: {
      get() {
        return this.$store.state.settings.showSettings
      },
      set(val) {
        this.$store.dispatch('settings/changeSetting', {
          key: 'showSettings',
          value: val
        })
      }
    },
    topNav: {
      get() {
        return this.$store.state.settings.topNav
      }
    },
    // avatar: {
    //   get() {
    //     let user = JSON.parse(sessionStorage.getItem('user'))
    //     if (!user){
    //       this.$http.get(this.$api.home.getInfo).then((res) => {
    //         if (res.data.code == 200) {
    //           sessionStorage.setItem('user', JSON.stringify(res.data.data))
    //           return res.data.data
    //         }
    //       })
    //     }else {
    //       return user
    //     }
    //   }
    //
    // }
  },
  watch: {
    // 监听路由对象中的变化
    $route: {
      handler: function (to, from) {
        // 当路由发生变化时会调用这个函数
        // to 和 from 分别代表到达的路由和离开的路由
        this.getRouteChange(to.path);
        // 在这里可以根据路由变化执行相应的逻辑
      },
      // 如果需要在路由变化时立即响应，可以设置immediate为true
      immediate: true,
    },
  },
  methods: {
    /* 更新visible */
    updateDrawer(value) {
      this.$emit('update:visible', value);
    },
    getRouteChange() {
      this.currentPath = this.$route.path;
    },
    handleClick(item) {
      if (!item.path) {
        return this.updateDrawer(true)
      }
      const loading = this.$loading({
        lock: true,
        text: 'Loading',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      });
      this.$router.push({
        path: item.path,
      });
      this.currentPath = item.path;
      // 监听路由变化来判断跳转是否结束
      this.$router.onReady(() => {
        loading.close();
      });
    },
    async logout() {
      this.$confirm('确定注销并退出系统吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$http.get(this.$api.login.logout).then((res) => {
          if (res.data.code == 200) {
            sessionStorage.removeItem('user')
            this.$auth.removeKqToken()
            this.$router.push({
              path: "/customerEnterprise/login",
            });
          }
        });

      }).catch(() => {});
    },

    changeLogin(){
      this.$nextTick(() => {
        this.$refs.changeRef.show('选择登录账号')
      })
    }
  }
}
</script>

<style lang="less" scoped>
.icon-logo {
  width: 24px;
  height: 24px;
}

.navbar {
  height: 50px;
  overflow: hidden;
  position: fixed;
  top: 0;
  background: #0f0f0f;
  box-shadow: 0 1px 4px rgba(0,21,41,.08);
  display: flex;
  justify-content: space-between;
  z-index: 999;
  width: 100%;
  padding-left: 70px;
  padding-right: 70px;

  .hamburger-container {
    line-height: 46px;
    height: 100%;
    float: left;
    cursor: pointer;
    transition: background .3s;
    -webkit-tap-highlight-color:transparent;

    &:hover {
      background: rgba(0, 0, 0, .025)
    }
  }

  .breadcrumb-container {
    float: left;
  }

  .topmenu-container {
    position: absolute;
    left: 50px;
  }

  .errLog-container {
    display: inline-block;
    vertical-align: top;
  }

  .left-menu{
    height: 100%;
    display: flex;
    align-items: center;
  }

  .menu-top{
    color: rgba(255, 255, 255, 0.65);
    font-size: 14px;
    padding: 0 20px;

    &:hover {
      color: rgba(255, 255, 255, 1);
    }
  }

  .login-box{
    color: rgba(255, 255, 255, 0.65);
    font-size: 14px;
    padding: 0 10px;

    &:hover {
      color: rgba(255, 255, 255, 1);
    }
  }

  .right-menu {
    float: right;
    height: 100%;
    line-height: 50px;

    &:focus {
      outline: none;
    }

    .right-menu-item {
      display: inline-block;
      padding: 0 8px;
      height: 100%;
      font-size: 18px;
      color: #5a5e66;
      vertical-align: text-bottom;

      &.hover-effect {
        cursor: pointer;
        transition: background .3s;

        &:hover {
          background: rgba(0, 0, 0, .025)
        }
      }
    }

    .avatar-container {
      margin-right: 30px;

      .avatar-wrapper {
        position: relative;
        height: 50px;

        .user-avatar {
          cursor: pointer;
          width: 40px;
          height: 40px;
          border-radius: 10px;
        }

        .el-icon-caret-bottom {
          cursor: pointer;
          position: absolute;
          right: -20px;
          top: 30px;
          font-size: 12px;
          color: #ffffff;
        }
      }
    }
  }
}
</style>
